import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { PostUserKYCPayload, PostUserKYCResponse } from './types/Kyc';

export default (makeCall: MakeCall) =>
  (userId: 'me' | number, kycUUID: string, data: Partial<PostUserKYCPayload>) =>
    makeCall<PostUserKYCResponse>(
      'PUT',
      `/api/v2/user/${userId}/kyc/${kycUUID}`,
      {
        data,
      },
    );
